'use strict';

import controller from './selectDate.controller';
import template from './selectDate.html';
import './selectDate.scss';

const selectDateComponent = {
    bindings: {
        ngModel: '=',
        ngRequired: '<',
        label: '@',
        ngDisabled: '<'
    },
    controller,
    template
};

export default selectDateComponent;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/selectDate/selectDate.component.js